import { styled } from "@vitality-ds/system";
import { components } from "react-select";
import BaseDropdownIndicatorStyles from "./styles/BaseDropdownIndicator.styles";
var DropdownIndicator = components.DropdownIndicator;

// eslint-disable-next-line import/prefer-default-export
export var BaseDropdownIndicator = styled(DropdownIndicator, BaseDropdownIndicatorStyles);